export class ShippingAddressRequest {
  street: string | null;
  countryRegion: string;
  address: string;
  apartmentSuite: string | null;
  postalCode: string;
  city: string;
  rememberAddress: boolean;

  constructor(street: string | null, countryRegion: string, address: string, apartmentSuite: string, postalCode: string, city: string, rememberAddress: boolean) {
    this.street = street;
    this.countryRegion = countryRegion;
    this.address = address;
    this.apartmentSuite = apartmentSuite;
    this.postalCode = postalCode;
    this.city = city;
    this.rememberAddress = rememberAddress;
  }
}
